import { createAsyncThunk } from '@reduxjs/toolkit';
import { AxiosError } from 'axios';

import { axiosPrivate } from '../../modules/networkTools/networkTools';

export type FilesItem = {
  id: number;
  uploadDateTime: string | null;
  fileExtension: string | null;
  fileName: string | null;
  ownerFirstName: string | null;
  ownerLastName: string | null;
};

export const getFiles = createAsyncThunk(
  'files/getFiles',
  async (
    {
      clientId,
      page = 0,
      size = 99999,
      sorts
    }: {
      clientId: string | number;
      page?: number;
      size?: number;
      sorts?: { title: string; direction: string }[] | null;
    },
    { rejectWithValue }
  ) => {
    try {
      let params: string | string[] = '';
      if (Array.isArray(sorts) && sorts.length > 0) {
        params = sorts
          .filter((item) => item.direction && item.title)
          .map((item) => `&sort=${item.title},${item.direction}`)
          .join('');
      }

      const response = await axiosPrivate.get(
        `client/${clientId}/attachments?page=${page}&size=${size}${params}`
      );
      return { content: response.data, page, size, sorts };
    } catch (error: any | AxiosError) {
      if (error.response && error.response.data.errors) {
        return rejectWithValue(error.response.data.errors);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

export const getFilesPreview = createAsyncThunk(
  'files/getFilesPreview',
  async ({ clientId }: { clientId: string | number }, { rejectWithValue }) => {
    try {
      const response = await axiosPrivate.get(`client/${clientId}/attachments?page=0&size=4`);
      return response.data;
    } catch (error: any | AxiosError) {
      if (error.response && error.response.data.errors) {
        return rejectWithValue(error.response.data.errors);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

export const putFile = createAsyncThunk(
  'files/putFile',
  async (
    {
      clientId,
      fileId,
      data
    }: {
      clientId: string | number;
      fileId: string | number;
      data: any;
    },
    { rejectWithValue }
  ) => {
    try {
      const response = await axiosPrivate.put(`client/${clientId}/attachments/${fileId}`, data);
      return response;
    } catch (error: any | AxiosError) {
      if (error.response && error.response.data.errors) {
        return rejectWithValue(error.response.data.errors);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

export const deleteFile = createAsyncThunk(
  'files/deleteFile',
  async (
    {
      clientId,
      fileId
    }: {
      clientId: string | number;
      fileId: string | number;
    },
    { rejectWithValue }
  ) => {
    try {
      await axiosPrivate.delete(`client/${clientId}/attachments/${fileId}`);

      return fileId;
    } catch (error: any | AxiosError) {
      if (error.response && error.response.data.errors) {
        return rejectWithValue(error.response.data.errors);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);
